import React, { Component } from 'react';
import Select from 'react-select';
import { isEmptyObject } from '../../core/util/object';
import { analyticsTrackEvent } from '../../core/analytics/index';
import { ONE_CLICK_BOOK_TOUCH_CHANGE_PROFILE } from '../../core/analytics/events';
import { getNameInitialsFromFullName } from '../../core/util/string';
import { getFullNameFromSnakeCaseProps } from '../../core/util/account';

export const getSelectorOption = (userProfile: any) => {
  if (!isEmptyObject(userProfile) && !isEmptyObject(userProfile.user_profile_id)) {
    return {
      key: userProfile.user_profile_id,
      label: getFullNameFromSnakeCaseProps(userProfile),
      value: userProfile.user_profile_id,
    };
  }

  return null;
};

const labelStyle = {
  color: '#5b6b7d',
};

type SelectOptionProps = {
  className?: string;
  isDisabled?: boolean;
  isFocused?: boolean;
  isSelected?: boolean;
  onFocus?: (...args: any[]) => any;
  onSelect?: (...args: any[]) => any;
  option: any;
};

class SelectOption extends Component<SelectOptionProps> {
  constructor(props: SelectOptionProps) {
    super(props);
    this.handleMouseDown = this.handleMouseDown.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseMove = this.handleMouseMove.bind(this);
  }

  handleMouseDown(event: any) {
    event.preventDefault();
    event.stopPropagation();

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onSelect(this.props.option, event);
  }

  handleMouseEnter(event: any) {
    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onFocus(this.props.option, event);
  }

  handleMouseMove(event: any) {
    if (this.props.isFocused) return;

    // @ts-expect-error ts-migrate(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    this.props.onFocus(this.props.option, event);
  }

  render() {
    let style = {
      backgroundColor: '#5b6b7d',
      borderRadius: '50%',
      color: '#fff',
      height: 35,
      marginRight: 15,
      marginTop: 0,
      marginBottom: 0,
      textAlign: 'center',
      width: 35,
      lineHeight: '35px',
      display: 'inline-block',
      fontSize: '16px',
    };

    const fullName =
      typeof this.props.children === 'string'
        ? this.props.children
        : // @ts-expect-error ts-migrate(2533) FIXME: Object is possibly 'null' or 'undefined'.
          this.props.children.props.children;

    return (
      <div
        className={`${this.props.className} inspectlet-sensitive`}
        onMouseDown={this.handleMouseDown}
        onMouseEnter={this.handleMouseEnter}
        onMouseMove={this.handleMouseMove}
        style={labelStyle}
        title={this.props.option.title}
      >
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type '"center" ... Remove this comment to see the full error message */}
        <div style={style}>{getNameInitialsFromFullName(fullName, '')}</div>
        {fullName}
      </div>
    );
  }
}

type SelectValueProps = {
  placeholder?: string;
  value?: any;
  customArrow?: boolean;
  children?: React.ReactNode | ((...args: any[]) => any) | string;
};

const SelectValue = (props: SelectValueProps) => {
  const style = {
    backgroundColor: '#5b6b7d',
    borderRadius: '50%',
    color: '#fff',
    height: 35,
    marginRight: 15,
    marginTop: 0,
    marginBottom: 0,
    textAlign: 'center',
    width: 35,
    lineHeight: '35px',
    display: 'inline-block',
    fontSize: '16px',
  };

  const inactiveLabelStyle = {
    ...labelStyle,
    fontSize: '16px',
    overflow: 'hidden',
    padding: '8px 0',
    textOverflow: 'ellipsis',
  };

  const fullName = props.value.label;

  return (
    <div className="Select-value inspectlet-sensitive" title={fullName}>
      <div className="Select-value-label" style={inactiveLabelStyle}>
        {/* @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type '"center" ... Remove this comment to see the full error message */}
        <div style={style}>{getNameInitialsFromFullName(fullName, '')}</div>
        {fullName}
      </div>
    </div>
  );
};

const arrowRenderer = () => (
  <span>
    <img alt="Select" src="/images/carats/carat_down_gray.svg" />
  </span>
);

type OwnUserProfileSelectorProps = {
  field?: any;
  accountSummary?: any;
  handleChangeUserProfile?: (...args: any[]) => any;
  id?: string;
  userProfileId?: string;
  s?: any;
  arrowRenderer?: (...args: any[]) => any;
  onBlur?: (...args: any[]) => any;
  onFocus?: (...args: any[]) => any;
  inputProps?: any;
};

// @ts-expect-error ts-migrate(2456) FIXME: Type alias 'UserProfileSelectorProps' circularly r... Remove this comment to see the full error message
type UserProfileSelectorProps = OwnUserProfileSelectorProps &
  typeof UserProfileSelector.defaultProps;

// @ts-expect-error ts-migrate(7022) FIXME: 'UserProfileSelector' implicitly has type 'any' be... Remove this comment to see the full error message
const UserProfileSelector = (props: UserProfileSelectorProps) => {
  const getSelectorOptions = () => {
    const profiles = props.accountSummary.user_profiles.filter(
      (profile: any) => profile && profile.is_verified
    );
    return profiles.map((profile: any) => getSelectorOption(profile));
  };

  const onChangeUserProfile = (value: any) => {
    analyticsTrackEvent(ONE_CLICK_BOOK_TOUCH_CHANGE_PROFILE);
    props.field.onChange(value);
    props.handleChangeUserProfile(props, value.value);
  };

  const handleFocus = () => {
    props.onFocus && props.onFocus(props.id);
  };

  const handleBlur = () => {
    props.onBlur && props.onBlur(props.id);
  };

  const value = !isEmptyObject(props.inputProps) ? props.inputProps.value : props.field.value;

  return (
    <Select
      // TODO: react-select (v1) doesn't seem to respect aria-label although docs claim it should.
      aria-label="Select profile"
      arrowRenderer={props.arrowRenderer}
      autoBlur
      className={props.s.reactSelect}
      clearable={false}
      field={props.field}
      multi={false}
      onBlur={handleBlur}
      onChange={onChangeUserProfile}
      onFocus={handleFocus}
      optionComponent={SelectOption}
      options={getSelectorOptions()}
      placeholder="Select profile ..."
      searchable={false}
      tabSelectsValue
      value={value}
      valueComponent={SelectValue}
    />
  );
};

UserProfileSelector.defaultProps = {
  arrowRenderer,
};

export default UserProfileSelector;
